import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Loader2, Briefcase, IndianRupee, Calendar } from "lucide-react";
import { toast } from "sonner";

export default function Mentors() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/mentors").then((r) => setList(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="max-w-3xl mb-10">
        <div className="overline mb-3">Mentor Marketplace</div>
        <h1 className="text-4xl sm:text-5xl font-semibold text-brand-blue leading-tight">Industry mentors for teens.</h1>
        <p className="mt-4 text-lg text-brand-muted">Scientists, founders, doctors, designers, and researchers — sharing time with the next generation.</p>
      </div>

      {!list ? <Loader2 className="animate-spin text-brand-green mx-auto" /> : (
        <div className="grid md:grid-cols-2 gap-6">
          {list.map((m) => (
            <div key={m.id} data-testid={`mentor-card-${m.id}`} className="surface surface-hover p-7">
              <div className="flex gap-4 items-start">
                <div className="w-14 h-14 rounded-2xl bg-brand-green text-white font-heading font-semibold flex items-center justify-center shrink-0">{m.name.split(" ").map(n => n[0]).slice(0,2).join("")}</div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-brand-blue">{m.name}</h3>
                  <div className="text-sm text-brand-muted flex items-center gap-1 mt-1"><Briefcase size={13} /> {m.role} • {m.field}</div>
                </div>
                <span className="chip">{m.experience_years} yrs</span>
              </div>
              <p className="mt-4 text-brand-blue leading-relaxed">{m.bio}</p>
              <div className="mt-5 flex items-center justify-between">
                <div className="flex flex-wrap gap-1.5">
                  {m.languages.map((l) => <span key={l} className="chip-blue">{l}</span>)}
                </div>
                <span className="flex items-center gap-1 text-brand-blue font-medium"><IndianRupee size={13} /> {m.session_rate}/session</span>
              </div>
              <button data-testid={`mentor-book-${m.id}`} onClick={() => toast.success(`Session request sent to ${m.name}.`)} className="btn-primary mt-5 w-full"><Calendar size={14} /> Book a session</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
